module.exports = "/_next/static/images/arrow-rotate-3b67f8df1517c3de3cfe1e2e959a83c8.png";